// Import global utils
import { isEmpty } from '@automator/shared/utils/is-empty';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __ } from '@wordpress/i18n';

// Import recipe builder services
import { getItem } from '@automator/builder/services/item';

// Import recipe builder utils
import { builderFetch } from '@automator/builder/utils';

/**
 * Sets the schedule status of an action
 *
 * @param {Number} itemID The item ID
 * @param {Object} fields The fields to be saved in the meta for the schedule
 * @return {Promise} The apiFetch promise
 */
const setSchedule = async ( itemID, fields = {} ) => {
	// Event name
	const eventName = 'uap/builder/core/item/action-schedule/set-schedule';

	// Get the action
	const action = getItem( 'action', itemID );

	// If the item is not define, stop here
	if ( isEmpty( action ) ) {
		throw new Error( `setSchedule: The action ${ itemID } doesn't exist` );
	}

	// Save the recipe title
	return builderFetch( {
		eventName: eventName,
		endpoint: 'schedule_action',
		method: 'POST',
		data: Object.assign( {
			recipeId: UncannyAutomator._recipe.recipe_id,
			actionId: itemID
		}, fields ),
		snackbar: {
			loading: fields.asyncMode === 'delay'
				? escapeHTML( __( 'Saving delay', 'uncanny-automator' ) )
				: escapeHTML( __( 'Saving schedule date', 'uncanny-automator' ) ),
			success: fields.asyncMode === 'delay'
				? escapeHTML( __( 'Delay saved successfully', 'uncanny-automator' ) )
				: escapeHTML( __( 'Schedule date saved successfully', 'uncanny-automator' ) ),
		}
	} ).then( response => {
		// Check if the call was successful
		if ( response.success ) {
			// Send custom event to the document
			document.dispatchEvent( new CustomEvent( eventName, {
				detail: {
					actionID: itemID,
					fields: fields
				}
			} ) );
		}

		return response;
	} );
}

export default setSchedule;
